<div class="screen-overlay flex-col text-center">
  <nz-empty></nz-empty>
  <!-- <nz-empty
    nzNotFoundImage="assets/empty-box.png"
    [nzNotFoundContent]="null"
  ></nz-empty>
  <h3 class="!min-w-auto">No results found</h3> -->
</div>
